import gql from 'graphql-tag';

export const gqlGetUsersLoginStats = gql`
  query getUsersLoginStats($fromDate: DateTime!, $tillDate: DateTime!, $groupBy: String!) {
    getUsersLoginStats(fromDate: $fromDate, tillDate: $tillDate, groupBy: $groupBy) {
      data {
        periodBucket
        platformOwner
        collector
        collectorDriver
        wasteReceptionPoint
        collectionPoint
        contributor
        total
      }
    }
  }
`;
